import { Fragment } from "react";
import MobileLink from "./MobileLink";
import INavigationArea from "../../../models/navigation/INavigationArea";
import INavigationSection from "../../../models/navigation/INavigationSection";

interface IMobileSection {
    area: INavigationArea;
    section: INavigationSection;
    onNavigate: () => void;
}

const MobileSection = (props: IMobileSection) => (
    <Fragment>
        {
            props.section.links
                .filter((link) => !link.isHidden)
                .map((link, index) => <MobileLink key={index} area={props.area.slug} link={link} onNavigate={props.onNavigate} />)
        }
    </Fragment>
);

export default MobileSection;